import Sortable from "stimulus-sortable";

export default class extends Sortable {
  async onUpdate(event) {
    await super.onUpdate(event);
    this.element.closest("form")?.requestSubmit();
  }
}
